import { PortfolioSidebar } from '../../../components/portfolio-sidebar';

import { PortfolioPerformanceAccountsSection } from './portfolio-performance-list-accounts';
import './styles.scss';

interface Iprops {
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  accountGroups: any[];
}

export const PortfolioPerformanceSidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  accountGroups,
}: Iprops) => {
  return (
    <PortfolioSidebar
      isPortfolioSidebarOpen={isSidebarOpen}
      setIsPortfolioSidebarOpen={setIsSidebarOpen}
      resizable
    >
      <div
        className={`portfolio-sidebar-wrapper ${isSidebarOpen ? 'portfolio-sidebar-content-sidebar-open' : 'portfolio-sidebar-content-sidebar-close'}`}
      >
        <div className={`portfolio-list-container`}>
          <PortfolioPerformanceAccountsSection
            isSidebarOpen={isSidebarOpen}
            accountGroups={accountGroups}
          />
        </div>
      </div>
    </PortfolioSidebar>
  );
};
